import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {Card, Col, Form, Row} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCloudArrowDown} from "@fortawesome/free-solid-svg-icons";
import {selectLang, Translate, updateShowInProgressAsync} from "../../app/store/reducers/main/mainReducer";

const FileUploader = ({errorMessage, acceptedFiles, onFileChanged}) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const dispatch = useDispatch();
    const lang = useSelector(selectLang);
    const t = Translate;

    useEffect(() => {
        if (selectedFile) {
            parseFile();
        }
    }, [selectedFile])

    const onSelectFile = event => {
        const [file] = event.target.files;
        setSelectedFile(file);
    };

    const parseFile = () => {
        dispatch(updateShowInProgressAsync(true));
        readFileAsync().finally(() => {
            dispatch(updateShowInProgressAsync(false));
        })
    }

    const readFileAsync = () => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(selectedFile);

            reader.onload = e => {
                const base64Content = e.target.result;
                onFileChanged({
                    content: base64Content,
                    name: selectedFile.name,
                    size: selectedFile.size,
                });
                resolve();
            }

            reader.onerror = err => {
                reject(err);
            }
        })
    }

    return (
        <Row>
            <Col xs={12}>
                <Card className={'my-3 shadow-none border-dashed bg-light'}>
                    <Form.Control
                        type={'file'}
                        id={'fileUploader'}
                        className={'d-none'}
                        accept={acceptedFiles}
                        onChange={onSelectFile}
                        isInvalid={!!errorMessage}
                    />

                    <Card.Body as={'label'} htmlFor={'fileUploader'} className={'text-center cursor-pointer py-4'}>
                        <h4>
                            <FontAwesomeIcon icon={faCloudArrowDown}/>
                            <span className={'ms-2'}>{t(lang, 'common.upload_file')}</span>
                        </h4>
                        {errorMessage && <small className="text-danger my-0">{errorMessage}</small>}
                        {selectedFile && <span>{selectedFile?.name}</span>}
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
};

export default FileUploader;